import Model from "../Model";

class Shops extends Model{

    buildUrl ({ param }) {
        return ['shops', param];
    }

    all(config = {}) {
        return this.request({ method: 'GET', action: 'all', ...config });
    }
}


export default new Shops;